import React from 'react';

import { Button, Typography } from '@mui/material';
import { BarChart3 } from 'lucide-react';
import { makeStyles } from 'tss-react/mui';

const useChartFieldsPromptStyles = makeStyles()(theme => ({
  icon: {
    color: theme.palette.text.disabled,
    marginBottom: theme.spacing(0.5),
  },
  prompt: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    justifyContent: 'center',
    textAlign: 'center',
  },
}));

/**
 * Fills the Chart card's plot area until the Chart has Dimensions to query, so an
 * unconfigured Chart still occupies a Chart-sized card and points at the Fields panel.
 */
export function WorkflowListChartFieldsPrompt({
  onChoose,
  readOnly,
}: {
  onChoose: () => void;
  readOnly: boolean;
}) {
  const { classes } = useChartFieldsPromptStyles();

  return (
    <div className={classes.prompt}>
      <BarChart3 className={classes.icon} size={40} strokeWidth={1.5} />
      <Typography variant="h6">Choose fields to preview your chart</Typography>
      <Typography color="textSecondary" variant="body2">
        Add at least one category in chart fields to visualize these workflows.
      </Typography>
      {!readOnly && (
        <Button variant="outlined" onClick={onChoose}>
          Choose chart fields
        </Button>
      )}
    </div>
  );
}
